import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div style={{ textAlign: 'center', padding: '64px 24px', maxWidth: 480, margin: '0 auto' }}>
    <h1 style={{ fontSize: 28, marginBottom: 12 }}>Page not found</h1>
    <p style={{ color: '#666', marginBottom: 24 }}>That URL doesn’t match any page on this site.</p>
    <Link
      to="/"
      style={{
        display: 'inline-block',
        padding: '12px 24px',
        background: '#0B1C24',
        color: '#fff',
        textDecoration: 'none',
        borderRadius: 4,
        fontWeight: 600,
        marginRight: 12,
      }}
    >
      Home
    </Link>
    <Link to="/shop" style={{ color: '#0066cc', fontWeight: 600 }}>
      Shop all
    </Link>
  </div>
);

export default NotFound;
